module.exports = __webpack_public_path__ + "assets/6401315d75b58b6946129b0d797f1259.png";